import { Spinner, Stack, useMediaQuery } from '@chakra-ui/react';
import MainCard from '../../../../components/MainCard/Index';
import ProjectDeliveryMobilePage from './ProjectDeliveryMobilePage';
import ProjectDeliveryContentPage from './ProjectDeliveryContent';

const ProjectDeliveryCandidateArea: React.FC = () => {
  const [isMobile] = useMediaQuery('(max-width: 1024px)');

  // TODO: Criar hook para buscar dados da etapa de entrega de projeto
  const isLoadingData = false;

  if (isMobile)
    return (
      <ProjectDeliveryMobilePage>
        <ProjectDeliveryContentPage isMobile />
      </ProjectDeliveryMobilePage>
    );

  return (
    <>
      <MainCard title="ÁREA DO CANDIDATO " subtitle="- ENTREGA DE PROJETO">
        {isLoadingData ? (
          <Stack align="center" justify="center">
            <Spinner />
          </Stack>
        ) : (
          <ProjectDeliveryContentPage />
        )}
      </MainCard>
    </>
  );
};

export default ProjectDeliveryCandidateArea;
